import { render, staticRenderFns } from "./digit-c1.vue?vue&type=template&id=ffd61e7e&"
import script from "./digit-c1.vue?vue&type=script&lang=js&"
export * from "./digit-c1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports